import { createContext, useContext } from 'react';

import { type MeQuery } from '@/graphql';

export interface AuthenticatedGuardContextType {
  currentUser?: MeQuery['me'];
  logOut: () => void;
}

export const AuthenticatedGuardContext = createContext<AuthenticatedGuardContextType | null>(null);
export const useAuthenticatedGuardContext = (): AuthenticatedGuardContextType =>
  useContext(AuthenticatedGuardContext) as AuthenticatedGuardContextType;
